// extracted by mini-css-extract-plugin
export default {"phraseBlock":"ParaphraseOption_phraseBlock__Da4iy","deletePhraseButton":"ParaphraseOption_deletePhraseButton__yfzOA"};